import { Typography } from '@mui/material';
import React from 'react';

import { Checkbox, FormControlLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PasswordField from '../components/PasswordField';
import StyledLink from '../components/styles/StyledLink';
import {
  Root,
  StyledHeading,
  StyledTextField,
  StyledTypography,
} from '../components/styles/styles';
import './LoginCreateUser.scss';
import { StyledButton, StyledButtonGroup } from '../components/styles/StyledButtons';
import StyledSection from '../components/styles/StyledSection';

function LoginWrapper(props: BaseLoginProps) {
  const navigate = useNavigate();

  return <Login navigate={navigate} {...props} />;
}

interface BaseLoginProps {
  forwardUrl?: string;
}

interface LoginProps extends BaseLoginProps {
  navigate?: (path: string) => void;
}

interface State {
  email: string;
  password: string;
  remember: boolean;
  error: string | null;
  passwordVisible: boolean;
  submitting: boolean;
}

class Login extends React.Component<LoginProps, State> {
  constructor(props: LoginProps) {
    super(props);
    this.state = {
      email: localStorage.getItem('email') || '',
      password: '',
      remember: Boolean(localStorage.getItem('email')),
      error: null,
      passwordVisible: false,
      submitting: false,
    };
  }

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      passwordVisible: !prevState.passwordVisible,
    }));
  };

  handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value, type, checked } = event.target;
    if (type === 'checkbox') {
      this.setState({ ...this.state, [name]: checked });
    } else {
      this.setState({ ...this.state, [name]: value });
    }
  }

  handleSubmit(_event?: React.FormEvent) {}

  render() {
    const { remember, error } = this.state;
    return (
      <Root>
        <StyledSection tone="tone1">
          <StyledHeading>Login</StyledHeading>

          <form className="login-create-user" onSubmit={(event) => this.handleSubmit(event)}>
            <StyledTextField
              label="Email"
              name="email"
              type="email"
              fullWidth
              required
              onChange={(event) => this.handleChange(event as React.ChangeEvent<HTMLInputElement>)}
              placeholder="Email"
            />
            <PasswordField
              label="Password"
              name="password"
              onChange={(event) => this.handleChange(event)}
            />
            <StyledTypography variant="body2" align="right">
              <StyledLink
                tone="default"
                href={`/forgotPassword${this.state.email ? `/${this.state.email}` : ''}${
                  this.props.forwardUrl ? `?forwardUrl=${this.props.forwardUrl}` : ''
                }`}
              >
                Reset Password.
              </StyledLink>
            </StyledTypography>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={remember}
                  onChange={(event) => this.handleChange(event)}
                />
              }
              label="Remember Me"
            />
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <StyledButtonGroup>
              <StyledButton type="submit">Sign In</StyledButton>
            </StyledButtonGroup>
            <Typography
              variant="body2"
              align="center"
              style={{ margin: '16px 0 8px 0', color: '#666' }}
            >
              or
            </Typography>
            <StyledButtonGroup>
              <StyledButton
                type="button"
                variant="outlined"
                onClick={() => this.props.navigate?.('/cross-device-login')}
              >
                Sign in with Mobile
              </StyledButton>
            </StyledButtonGroup>
          </form>
        </StyledSection>
      </Root>
    );
  }
}

export default LoginWrapper;
